"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InCall = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdk_core_1 = require("@streem/sdk-core");
const fullscreen_portal_1 = require("../components/fullscreen_portal");
const spectator_call_frame_1 = require("../components/in_call/spectator/spectator_call_frame");
const company_info_1 = require("../context/company_info");
const room_session_1 = require("../context/room_session");
const company_settings_1 = require("../context/company_settings");
const user_session_1 = require("../context/user_session");
const use_on_call_end_1 = require("../hooks/use_on_call_end");
const call_log_1 = require("../context/call_log");
function InCall({ roomSession, userSession, onEnd, toolSettings, companyInfo, getRoomCallLogHistory, }) {
    if (!(0, sdk_core_1.isRoomSession)(roomSession)) {
        throw new sdk_core_1.StreemError('Unable to provide in-call experience without a RoomSession.');
    }
    (0, use_on_call_end_1.useOnCallEnd)(roomSession.roomId, onEnd);
    const RoomSessionProvider = (0, room_session_1.createRoomSessionProvider)(roomSession);
    const CompanySettingsProvider = (0, company_settings_1.createCompanySettingsProvider)(toolSettings);
    const UserSessionProvider = (0, user_session_1.createUserSessionProvider)(userSession);
    const CompanyInfoProvider = (0, company_info_1.createCompanyInfoProvider)(companyInfo);
    const HostCallLogProvider = (0, call_log_1.createHostRecentCallLogProvider)(getRoomCallLogHistory);
    return ((0, jsx_runtime_1.jsx)(fullscreen_portal_1.FullscreenPortal, Object.assign({ className: "InCallPortal" }, { children: (0, jsx_runtime_1.jsx)(RoomSessionProvider, { children: (0, jsx_runtime_1.jsx)(CompanySettingsProvider, { children: (0, jsx_runtime_1.jsx)(CompanyInfoProvider, { children: (0, jsx_runtime_1.jsx)(UserSessionProvider, { children: (0, jsx_runtime_1.jsx)(HostCallLogProvider, { children: (0, jsx_runtime_1.jsx)(spectator_call_frame_1.SpectatorCallFrame, {}) }) }) }) }) }) })));
}
exports.InCall = InCall;
//# sourceMappingURL=spectator_in_call.js.map